import { lazy } from 'react';
// ----------------------------------------------------------------------

const StudentByTypePage = lazy(() => import('../pages/StudentByType.page'));


// ----------------------------------------------------------------------

const StudentByTypeRoutes = [
    {
        path: 'sales',
        children: [
            { element: <StudentByTypePage />, layout: 'default', isAuthReq: true, index: true },
            // {
            //     path: 'add-student',
            //     element: <AddStudentPage />,
            //     layout: 'default',
            //     isAuthReq: true,
            // },



        ],
    },

];

export { StudentByTypeRoutes };
